<template>
  <div class="menu-row" @click="$emit('click')">
    <img class="point-img" :src="image" :alt="title">
    <span>{{title}}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    image: {
      type: String,
      default: '',
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-row {
  display: flex;
  align-items: center;
  img {
    width: 16px;
    margin-right: 8px;
    &.point-img {
      margin-top: 3px;
    }
  }
  span {
    font-weight: bold;
  }
}
</style>
